export const SENDING_USER_LIST_REQUEST = 'SENDING_USER_LIST_REQUEST';
export const GET_USER_LIST = 'GET_USER_LIST';
export const SET_USER_LIST = 'SET_USER_LIST';
export const USER_LIST_REQUEST_FAILED = 'USER_LIST_REQUEST_FAILED';

export const SENDING_USER_FAVORITES_REQUEST = 'SENDING_USER_FAVORITES_REQUEST';
export const GET_USER_FAVORITES = 'GET_USER_FAVORITES';
export const SET_USER_FAVORITES = 'SET_USER_FAVORITES';
export const USER_FAVORITES_REQUEST_FAILED = 'USER_FAVORITES_REQUEST_FAILED';

export const SENDING_ADD_FAVORITES_REQUEST = 'SENDING_ADD_FAVORITES_REQUEST';
export const GET_ADD_FAVORITES = 'GET_ADD_FAVORITES';
export const SET_ADD_FAVORITES = 'SET_ADD_FAVORITES';
export const ADD_FAVORITES_REQUEST_FAILED = 'ADD_FAVORITES_REQUEST_FAILED';

export const SENDING_DELETE_FAVORITES_REQUEST = 'SENDING_DELETE_FAVORITES_REQUEST';
export const GET_DELETE_FAVORITES = 'GET_DELETE_FAVORITES';
export const SET_DELETE_FAVORITES = 'SET_DELETE_FAVORITES';
export const DELETE_FAVORITES_REQUEST_FAILED = 'DELETE_FAVORITES_REQUEST_FAILED';

export const SENDING_DASHBOARD_LIST_REQUEST = 'SENDING_DASHBOARD_LIST_REQUEST';
export const GET_DASHBOARD_LIST = 'GET_DASHBOARD_LIST';
export const SET_DASHBOARD_LIST = 'SET_DASHBOARD_LIST';
export const DASHBOARD_LIST_REQUEST_FAILED = 'DASHBOARD_LIST_REQUEST_FAILED';

export const SENDING_DASHBOARD_URLS_REQUEST = 'SENDING_DASHBOARD_URLS_REQUEST';
export const GET_DASHBOARD_URLS = 'GET_DASHBOARD_URLS';
export const SET_DASHBOARD_URLS = 'SET_DASHBOARD_URLS';
export const DASHBOARD_URLS_REQUEST_FAILED = 'DASHBOARD_URLS_REQUEST_FAILED';

export const SET_CURRENT_DASHBOARD = 'SET_CURRENT_DASHBOARD';

export const SENDING_SAGEMAKER_URL_REQUEST = 'SENDING_SAGEMAKER_URL_REQUEST';
export const GET_SAGEMAKER_URL = 'GET_SAGEMAKER_URL';
export const SET_SAGEMAKER_URL = 'SET_SAGEMAKER_URL';
export const SAGEMAKER_URL_REQUEST_FAILED = 'SAGEMAKER_URL_REQUEST_FAILED';
export const SET_SAGEMAKER_URL_EXIST = 'SET_SAGEMAKER_URL_EXIST';

export const SENDING_REPORT_MENUS_REQUEST = 'SENDING_REPORT_MENUS_REQUEST';
export const GET_REPORT_MENUS = 'GET_REPORT_MENUS';
export const SET_REPORT_MENUS = 'SET_REPORT_MENUS';
export const REPORT_MENUS_REQUEST_FAILED = 'REPORT_MENUS_REQUEST_FAILED';

export const SENDING_USER_ONBOARDING_REQUEST = 'SENDING_USER_ONBOARDING_REQUEST';
export const GET_USER_ONBOARDING = 'GET_USER_ONBOARDING';
export const SET_USER_ONBOARDING = 'SET_USER_ONBOARDING';
export const USER_ONBOARDING_REQUEST_FAILED = 'USER_ONBOARDING_REQUEST_FAILED';

export const SENDING_USER_DETAILS_REQUEST = 'SENDING_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const USER_DETAILS_REQUEST_FAILED = 'USER_DETAILS_REQUEST_FAILED';

export const SENDING_USER_GUIDE_REQUEST = 'SENDING_USER_GUIDE_REQUEST';
export const GET_USER_GUIDE = 'GET_USER_GUIDE';
export const SET_USER_GUIDE = 'SET_USER_GUIDE';
export const USER_GUIDE_REQUEST_FAILED = 'USER_GUIDE_REQUEST_FAILED';

export const SENDING_WHATS_NEW_REQUEST = 'SENDING_WHATS_NEW_REQUEST';
export const GET_WHATS_NEW = 'GET_WHATS_NEW';
export const SET_WHATS_NEW = 'SET_WHATS_NEW';
export const WHATS_NEW_REQUEST_FAILED = 'WHATS_NEW_REQUEST_FAILED';

export const SENDING_FAQS_REQUEST = 'SENDING_FAQS_REQUEST';
export const GET_FAQS = 'GET_FAQS';
export const SET_FAQS = 'SET_FAQS';
export const FAQS_REQUEST_FAILED = 'FAQS_REQUEST_FAILED';

export const SENDING_REQUEST_REPORT_REQUEST = 'SENDING_REQUEST_REPORT_REQUEST';
export const GET_REQUEST_REPORT = 'GET_REQUEST_REPORT';
export const SET_REQUEST_REPORT = 'SET_REQUEST_REPORT';
export const REQUEST_REPORT_REQUEST_FAILED = 'REQUEST_REPORT_REQUEST_FAILED';

export const SENDING_NOTIFICATION_REQUEST = 'SENDING_NOTIFICATION_REQUEST';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const NOTIFICATION_REQUEST_FAILED = 'NOTIFICATION_REQUEST_FAILED';

export const SET_LOGGED_IN_TOKEN = 'SET_LOGGED_IN_TOKEN';
